export const insert = <T>(arr: T[], index: number, newItem: T): T[] => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted item
    newItem,
    // part of the array after the specified index
    ...arr.slice(index)
];

export const remove = <T>(array: T[], index: number): T[] => (
    array.slice(0, index).concat(array.slice(index + 1, array.length))
);
